import Location from 'app-location'

export const UserNotificationsEndpoint = new Location('/v1/student/notifications')

export const UserNotificationsMarkAllEndpoint = new Location('/v1/student/notifications/mark_as_read')
